// export default {
//     BIG_IMG: "image_b",
//     SMALL_IMG: "image_s",
//     TEXT: "text"
// }

export default {
    BIG_IMG: "bigImage",
    SMALL_IMG: "smallImage",
    TEXT: "text"
}